import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ReactElement, useContext } from "react";

import { CollectionOrder, Sort } from "../../../../generated/gql/graphql";
import { CollectionsContext } from "../../../../providers/collections-provider";

export default function CollectionFilter(): ReactElement {
  const { sorting, setSorting } = useContext(CollectionsContext);

  function handleSortChange(e: SelectChangeEvent): void {
    const value = e.target.value;
    switch (value) {
      case "date_created":
        setSorting({
          date_created: Sort.Asc,
        });
        break;
      case "-date_created":
        setSorting({
          date_created: Sort.Desc,
        });
        break;
      case "name":
        setSorting({
          name: Sort.Asc,
        });
        break;
      case "-name":
        setSorting({
          name: Sort.Desc,
        });
        break;
    }
  }

  function sortToString(sort: CollectionOrder): string {
    if (sort.name) {
      switch (sort.name) {
        case Sort.Asc: {
          return "name";
        }
        case Sort.Desc: {
          return "-name";
        }
      }
    }

    if (sort.date_created) {
      switch (sort.date_created) {
        case Sort.Asc: {
          return "date_created";
        }
        case Sort.Desc: {
          return "-date_created";
        }
      }
    }

    // Note(john): default is the newest created collections
    return "-date_created";
  }

  return (
    <div className="flex w-full mb-[25px] flex-wrap">
      <div className="block basis-[65%]">
        {/* <UISelect className="mr-15" label="Shared with" name="shared" /> */}
      </div>
      <div className="block basis-[35%] text-right">
        <FormControl style={{ minWidth: 100 }} size="small">
          <InputLabel className="text-[14px]">Sort by</InputLabel>
          <Select
            className="border-0 rounded-[15px] text-[14px] text-left"
            label="Sort by"
            value={sortToString(sorting)}
            onChange={handleSortChange}
          >
            <MenuItem defaultChecked value="-date_created">
              Newest
            </MenuItem>
            <MenuItem value="date_created">Oldest</MenuItem>
            <MenuItem value="name">Sort A-Z</MenuItem>
            <MenuItem value="-name">Sort Z-A</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
}
